import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    head_title: 'Централизованная база данных подведомственных учреждений акимата Алматинской области',
  },
  kk: {
    head_title: 'Алматы облысы әкімдігінің ведомстволық бағынысты мекемелерінің орталықтандырылған деректер базасы',
  }
});
